import React from "react";

export function LoginBrandPanel() {
  return (
    <aside className="t-loginPage-aside" aria-hidden="false">
      <div className="t-loginPage-asideBg" aria-hidden="true" />
        <div className="t-loginPage-asideInner">
          <div className="t-loginPage-asideBody">
          <div className="t-loginPage-asideHero">
            <img
              src="/assets/img/login/emin-olmak-mark.png"
              alt="Emin Olmak"
              className="t-loginPage-eminOlmakMark"
              draggable={false}
            />
            <h2 className="t-loginPage-asideHeadline">
              EV, ARAÇ VE
              <br />
              İŞ YERİ HEDEFİNE
            </h2>
            <p className="t-loginPage-asideTagline">GÜVENLE ULAŞMAK DEMEK</p>
          </div>
          <img
            src="/assets/img/login/login-emin-keys.png"
            alt=""
            className="t-loginPage-asideKeys"
            aria-hidden="true"
          />
        </div>
      </div>
    </aside>
  );
}

export default LoginBrandPanel;
